import React, { useState } from 'react';

import { Navbar, NavbarBrand, NavItem, NavbarHeader, NavDropdown, Nav, Container, Row, Button, Col } from 'react-bootstrap';

import ReactDOM from 'react-dom/client';
import NavbarToggle from 'react-bootstrap';


function NavbarApp() {

    return (
        <>
            <Navbar collapseOnSelect expand="md" sticky="top" className="Navbar">
                <Container>
                    <Navbar.Brand className="me-auto" style={{ color: "var(--navbar-color)" }}>
                        <span className="Navbar-Title">Universal Coffee Pricing</span>
                    </Navbar.Brand>

                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="me-auto">
                            <Nav.Link exact href="/#/coffeePulse"><Button variant="" className="custom-btn-countries" size="sm"><i class="bi bi-activity"></i>&nbsp;&nbsp;Coffee Pulse</Button></Nav.Link>
                            <Nav.Link exact href="/#/"><Button variant="" className="custom-btn-countries" size="sm"><i class="bi bi-currency-dollar"></i>&nbsp;&nbsp;Price assessment</Button></Nav.Link>
                            <Nav.Link exact href="#" disabled><Button variant="" className="custom-btn-deactivated" size="sm"><i class="bi bi-person-circle"></i>&nbsp;&nbsp;Admin/Users</Button></Nav.Link>
                            <Nav.Link exact href="#" disabled><Button variant="" className="custom-btn-deactivated" size="sm"><i class="bi bi-plus-circle"></i>&nbsp;&nbsp;Mappings</Button></Nav.Link>
                            <Nav.Link exact href="#" disabled><Button variant="" className="custom-btn-deactivated" size="sm"><i class="bi bi-gear"></i>&nbsp;&nbsp;Rules</Button></Nav.Link>
                            <Nav.Link exact href="#" disabled><Button variant="" className="custom-btn-deactivated" size="sm"><i class="bi bi-cloud-upload"></i>&nbsp;&nbsp;Save changes</Button></Nav.Link>
                            <Nav.Link exact href="#" disabled><Button variant="" className="custom-btn-deactivated" size="sm"><i class="bi bi-check-circle"></i>&nbsp;&nbsp;EOD sign-off</Button></Nav.Link>

                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    );

}




export default NavbarApp;